export const DataTypes = {
  boolean: 'boolean',
  datetime: 'datetime',
  number: 'number',
  string: 'string',
  array: 'array',
  objectId: 'objectId'
};